export const LADE_AUSWAHLWERTE_CRM = "ladeAuswahlwerteCRM";
